var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 226,
    viewBox: "0 0 226 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_119_614745)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 220,
    height: 220,
    rx: 110,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 2.5,
    width: 219,
    height: 219,
    rx: 109.5,
    stroke: "#DBEAFE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.602 75.0021C156.683 75.002 158.678 75.8026 160.149 77.2279C161.62 78.6531 162.447 80.5861 162.447 82.6018C162.447 84.6174 161.621 86.5505 160.15 87.9759C158.679 89.4012 156.683 90.202 154.603 90.2021L198.309 90.2003C200.389 90.2002 202.385 91.0009 203.856 92.4261C205.327 93.8513 206.154 95.7844 206.154 97.8C206.154 99.8156 205.328 101.749 203.857 103.174C202.385 104.599 200.39 105.4 198.31 105.4L153.483 105.402C151.402 105.402 149.407 106.203 147.936 107.628C146.465 109.054 145.638 110.987 145.638 113.002C145.638 115.018 146.465 116.951 147.936 118.376C149.407 119.802 151.403 120.602 153.483 120.602L181.5 120.601C183.581 120.601 185.576 121.402 187.047 122.827C188.519 124.252 189.345 126.185 189.345 128.201C189.345 130.216 188.519 132.149 187.048 133.575C185.577 135 183.581 135.801 181.501 135.801L136.674 135.803C138.754 135.803 140.75 136.603 142.221 138.029C143.692 139.454 144.519 141.387 144.519 143.403C144.519 145.418 143.693 147.351 142.221 148.777C140.75 150.202 138.755 151.003 136.675 151.003L26.8486 151.007C24.768 151.007 22.7727 150.207 21.3014 148.782C19.8302 147.356 19.0036 145.423 19.0035 143.408C19.0035 141.392 19.8299 139.459 21.301 138.033C22.7721 136.608 24.7674 135.807 26.8479 135.807L71.6748 135.805C69.5943 135.806 67.5989 135.005 66.1277 133.58C64.6565 132.154 63.8299 130.221 63.8298 128.206C63.8297 126.19 64.6561 124.257 66.1272 122.832C67.5983 121.406 69.5936 120.606 71.6742 120.605L47.0194 120.606C44.9388 120.607 42.9434 119.806 41.4722 118.381C40.001 116.955 39.1744 115.022 39.1743 113.007C39.1742 110.991 40.0006 109.058 41.4718 107.633C42.9429 106.207 44.9382 105.407 47.0187 105.406L58.4204 105.406C63.8837 105.406 68.3114 102.003 68.3112 97.8056C68.311 93.6082 61.5868 90.2059 61.5868 90.2059C59.5063 90.206 57.5109 89.4053 56.0397 87.9801C54.5684 86.5549 53.7419 84.6218 53.7418 82.6062C53.7417 80.5905 54.5681 78.6574 56.0392 77.2321C57.5103 75.8067 59.5056 75.006 61.5862 75.0059L154.602 75.0021ZM34.6916 113.007C34.6917 114.51 34.2317 115.98 33.3698 117.229C32.5078 118.479 31.2827 119.453 29.8493 120.029C28.4159 120.604 26.8386 120.754 25.3168 120.461C23.7951 120.168 22.3973 119.444 21.3001 118.382C20.203 117.319 19.4558 115.965 19.153 114.49C18.8503 113.016 19.0055 111.488 19.5992 110.099C20.1929 108.71 21.1983 107.523 22.4884 106.688C23.7784 105.853 25.2951 105.407 26.8466 105.407C28.9271 105.407 30.9225 106.208 32.3938 107.633C33.865 109.058 34.6916 110.991 34.6916 113.007Z",
    fill: "#DBEAFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4987 87.1668C75.4987 84.8656 77.3642 83.0002 79.6654 83.0002H92.1654C94.4666 83.0002 96.332 84.8656 96.332 87.1668V91.3335C96.332 93.6347 94.4666 95.5002 92.1654 95.5002H79.6654C77.3642 95.5002 75.4987 93.6347 75.4987 91.3335V87.1668Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.665 87.1668C129.665 84.8656 131.531 83.0002 133.832 83.0002H146.332C148.633 83.0002 150.499 84.8656 150.499 87.1668V91.3335C150.499 93.6347 148.633 95.5002 146.332 95.5002H133.832C131.531 95.5002 129.665 93.6347 129.665 91.3335V87.1668Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6654 95.5002H92.1654V137.167H79.6654V95.5002Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.832 95.5002H146.332V137.167H133.832V95.5002Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4987 141.334C75.4987 139.032 77.3642 137.167 79.6654 137.167H92.1654C94.4666 137.167 96.332 139.032 96.332 141.334V145.5C96.332 147.801 94.4666 149.667 92.1654 149.667H79.6654C77.3642 149.667 75.4987 147.801 75.4987 145.5V141.334Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.665 141.334C129.665 139.032 131.531 137.167 133.832 137.167H146.332C148.633 137.167 150.499 139.032 150.499 141.334V145.5C150.499 147.801 148.633 149.667 146.332 149.667H133.832C131.531 149.667 129.665 147.801 129.665 145.5V141.334Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.332 149.667H112.999H154.665M79.6654 95.5002H92.1654M79.6654 95.5002C77.3642 95.5002 75.4987 93.6347 75.4987 91.3335V87.1668C75.4987 84.8656 77.3642 83.0002 79.6654 83.0002H92.1654C94.4666 83.0002 96.332 84.8656 96.332 87.1668V91.3335C96.332 93.6347 94.4666 95.5002 92.1654 95.5002M79.6654 95.5002V137.167M92.1654 95.5002V137.167M133.832 95.5002H146.332M133.832 95.5002C131.531 95.5002 129.665 93.6347 129.665 91.3335V87.1668C129.665 84.8656 131.531 83.0002 133.832 83.0002H146.332C148.633 83.0002 150.499 84.8656 150.499 87.1668V91.3335C150.499 93.6347 148.633 95.5002 146.332 95.5002M133.832 95.5002V137.167M146.332 95.5002V137.167M92.1654 137.167H79.6654M92.1654 137.167C94.4666 137.167 96.332 139.032 96.332 141.334V145.5C96.332 147.801 94.4666 149.667 92.1654 149.667H79.6654C77.3642 149.667 75.4987 147.801 75.4987 145.5V141.334C75.4987 139.032 77.3642 137.167 79.6654 137.167M146.332 137.167H133.832M146.332 137.167C148.633 137.167 150.499 139.032 150.499 141.334V145.5C150.499 147.801 148.633 149.667 146.332 149.667H133.832C131.531 149.667 129.665 147.801 129.665 145.5V141.334C129.665 139.032 131.531 137.167 133.832 137.167M112.999 103C108.396 103 104.665 105.984 104.665 109.667C104.665 113.35 108.396 116.333 112.999 116.333C117.601 116.333 121.332 119.317 121.332 123C121.332 126.684 117.601 129.667 112.999 129.667M112.999 103C116.082 103 118.776 104.34 120.218 106.334M112.999 103V99.6668M112.999 129.667V133M112.999 129.667C109.915 129.667 107.221 128.327 105.779 126.333M71.332 83.0002L112.999 66.3335L154.665 83.0002H71.332Z",
    stroke: "#3B82F6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_119_614745",
    x: 0,
    y: 0,
    width: 226,
    height: 226,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_119_614745"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_119_614745",
    result: "effect2_dropShadow_119_614745"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_119_614745",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccount);
export default __webpack_public_path__ + "static/media/noAccount.c77e457c5e1eb2a2eb87fee0de0c56d3.svg";
export { ForwardRef as ReactComponent };